import React from "react";
import ModalFiltering from "./FormElements/ModalFiltering";
import IconClose from "../Resources/svg/Icons/IconClose";

const ModalPoliticas = ({openModalMessagePCC, setOpenModalMessagePCC}) => {
  return (
    <div>
      <ModalFiltering
        className={`modal-result is-midle ${openModalMessagePCC && "is-open"}`}
        variant={true}
      >
        <div
          className="modal-filtering__close"
          onClick={() => setOpenModalMessagePCC(false)}
        >
          <IconClose />
        </div>
        <h2 className="modal-result__title">COMUNICACIONES COMERCIALES</h2>
        <div className="modal-result__content">
          <p
            style={{ textAlign: "justify" }}
            className="modal-result__subtitle"
          >
            Brindo mi consentimiento a RIMAC SEGUROS para tratar mis Datos
            Personales, con la finalidad de que me sean ofrecidos beneficios,
            productos y servicios prestados por RIMAC SEGUROS, lo cual me podrá
            ser comunicado por medios físicos (cartas enviadas a mi domicilio)
            y/o por medios electrónicos (mensajes de texto, correos
            electrónicos, llamadas telefónicas, entre otros); contando con el
            derecho a revocar este consentimiento en cualquier momento.
            <br />
            <br />
            Exclusivamente para la finalidad descrita en el párrafo precedente,
            RIMAC SEGUROS podrá realizar el tratamiento de mis Datos Personas
            por encargo a terceros. El listado de estos terceros se encuentra
            contemplado en el siguiente enlace:{" "}
            <a href="https://www.rimac.com.pe/" target="_blank" rel="noopener noreferrer">
              www.rimac.com.pe
            </a>
            <br />
            <br />
          </p>
        </div>
      </ModalFiltering>
    </div>
  );
};

export default ModalPoliticas;